import { useBulkImportStore } from '../hooks/useBulkImportStore'

import { type BulkImportStore, type SettingsBulkImport } from './bulk-import.store.types'

import { type FeedbackTypesCard } from '@/models/card-activity/card-activity.model'

const updateCardType = (newType: BulkImportStore['cardType']) => {
  useBulkImportStore.setState(state => {
    return {
      ...state,
      cardType: newType,
    }
  })
}

const updateSettings = (partial: Omit<Partial<SettingsBulkImport>, 'feedback' | 'grading'>) => {
  useBulkImportStore.setState(state => {
    const settings = state.settings

    const merged = {
      ...settings,
      ...partial,
    }

    return {
      ...state,
      settings: merged,
    }
  })
}

const updateGrading = (newGrading: Partial<SettingsBulkImport['grading']>) => {
  useBulkImportStore.setState(state => {
    // Merge incoming changes with current grading state
    const mergedGrading = {
      ...state.settings.grading,
      ...newGrading,
    }

    // Clear dependent fields based on changes
    const methodChanged = 'method' in newGrading;
    const standardChanged = 'standardId' in newGrading;

    if (methodChanged && newGrading.method !== 'standards_based') {
      mergedGrading.standardId = undefined;
      mergedGrading.target_proficiency_level = undefined;
    }


    return {
      ...state,
      settings: {
        ...state.settings,
        grading: mergedGrading, // Use the updated merged object
      },
    }
  })
}

const updateFeedback = (newFeedbacks: FeedbackTypesCard[]) => {
  useBulkImportStore.setState(state => {
    return {
      ...state,
      settings: {
        ...state.settings,
        feedback: newFeedbacks,
      },
    }
  })
}

export const functionsSettings = {
  updateCardType,
  updateSettings,
  updateFeedback,
  updateGrading,
}
